import http from "./http";

// GET current user + effective permissions
export const getMe = async () => {
  const res = await http.get("me");
  return res.data;
};
